<template>
  <div class="py-6 px-8">
    <h-header back="../../questionnaire">
      <template v-slot:actions>
        <v-btn
          v-if="canAddQuestions"
          @click="addQuestion"
          color="primary"
          elevation="0"
        >
          <v-icon left>mdi-plus</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('question.actions.addQuestion') }}
          </span>
        </v-btn>
      </template>
    </h-header>

    <h3 class="mb-5 ml-11 mt-n5 grey--text display-1">{{ questionnaireTitle }}</h3>

    <Questions v-if="hasQuestionnaireQuestions" :questions="questionnaireQuestions" />
    <EmptyQuestions v-if="isEmpty" />

    <h-loading v-show="isLoading" />

    <CreateUpdateQuestionModal ref="createUpdateQuestionModal" />
    <ModalQuestionConfirmDelete ref="confirmDeleteModal" @confirm="callRemoveQuestion" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { checkUserRole } from '@/util/helpers'

import CreateUpdateQuestionModal from '@/components/questionnaire/CreateUpdateQuestionModal'
import ModalQuestionConfirmDelete from '@/components/questionnaire/ModalQuestionConfirmDelete'
import EmptyQuestions from '../components/questionnaire/fragments/EmptyQuestions'
import Questions from '@/components/questionnaire/fragments/Questions'

export default {
  name: 'QuestionnaireQuestionsDetails',

  components: {
    CreateUpdateQuestionModal,
    ModalQuestionConfirmDelete,

    Questions,
    EmptyQuestions,
  },

  computed: {
    ...mapGetters(['isLoading', 'questionnaireQuestions', 'questionnaire']),

    canAddQuestions() {
      return !checkUserRole(['ROLE_SUPPORT'])
    },

    questionnaireTitle() {
      return this.questionnaire?.name ?? '---'
    },

    hasQuestionnaireQuestions() {
      return this.questionnaireQuestions?.length > 0
    },

    isEmpty() {
      return !this.hasQuestionnaireQuestions && !this.isLoading
    },
  },

  methods: {
    ...mapMutations(['setIsLoading']),
    ...mapActions(['fetchQuestionnaire', 'fetchQuestionnaireQuestions', 'deleteQuestion', 'showSuccessMessage', 'showErrorMessage']),

    addQuestion() {
      this.$refs.createUpdateQuestionModal.openCreateQuestionModal(this.id, this.questionnaireQuestions.length + 1)
    },

    callRemoveQuestion(question) {
      this.setIsLoading(true)
      const { id } = question

      this.deleteQuestion(id)
        .then(() => {
          this.fetchQuestionnaireQuestions(this.id)
          this.showSuccessMessage(this.$t("question.delete.deleteQuestion.successMessage"))
        })
        .catch(({data}) => this.showErrorMessage(data.message))
        .finally(() => this.setIsLoading(false))
    },
  },

  data() {
    return {
      id: this.$router.currentRoute.params.id,
      formatMoney: catalogMonetary,
      formatDate: catalogDate,
    }
  },

  mounted() {
    const id = this.$router.currentRoute.params.id

    if (id) {
      this.fetchQuestionnaire(id)
      this.fetchQuestionnaireQuestions(id)
    }
  },
}
</script>
